import serialize from './serialize';

const scrollTo = (id: unknown): void => document
  .getElementById(serialize(id))
  ?.scrollIntoView();

export default scrollTo;
